<template>
  <div class="studio-events-preview">
    <h1 class="mb-4">
      {{ data.title }}
    </h1>
    <CompactEventsList :events="limitedEvents" />
    <div v-if="remainingEventsLength > 0" class="mt-2">
      <NuxtLink
        class="undecorated-router-link"
        :to="{ name: 'studio-product-events' }"
      >
        <i class="fa fa-calendar-o c-brand-color me-2"></i>
        {{
          $t('PRODUCTS.LABELS.MORE_EVENTS_VARIANT', {
            remainingEventsLength,
          }, remainingEventsLength)
        }}
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useProductStore } from '@/stores';
import CompactEventsList from '@/components/events/CompactEventsList.vue';

export default {
  name: 'StudioEventsPreview',
  components: {
    CompactEventsList,
  },
  props: {
    limit: {
      type: Number,
      default: 3,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useProductStore, {
      product: 'product',
    }),
    events() {
      return this.product.events;
    },
    limitedEvents() {
      if (!this.events) return [];
      return this.events.slice(0, this.limit);
    },
    remainingEventsLength() {
      return Math.max(0, this.events.length - this.limit);
    },
  },
};
</script>
